module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-ma-3cc9895dc63d912d4b63ec6f967ddd8c.jpg";